module.exports = __webpack_public_path__ + "img/img_bed_web_en.f30feb39.png";